/* this might become a server component in the future. It depends on Linkbox */
'use client';

import { CmsHtml } from '@packages/modules/src/CmsHtml/CmsHtml.client';
import { classes } from '../../utils/classes';
import { mapButtonTypeToLayout } from '../../utils/mapButtonTypeToLayout';
import { LinkByButton } from '../LinkByButton/LinkByButton.client';
import { LinkByText } from '../LinkByText/LinkByText.client';
import { SoftHyphenInjector } from '../SoftHyphenInjector';
import type { LinkBoxItemContentComponentType } from './types';

/**
 * The LinkBoxItemContent component displays content of the LinkBox
 */
export const LinkBoxItemContent = ({
  data: {
    // content
    field_subline_90: subline,
    field_headline_120: headline,
    field_html_editor: htmlContent,
    // call to action
    field_button_text: buttonText,
    // cta button
    behavior_paragraph_cta_icon: buttonIcon,
    behavior_paragraph_cta_size: buttonSize = 'small',
    behavior_paragraph_cta_type: buttonType = 'button-default',
    // Options:
    // 	• standard (without background color)
    // 	• boxed (with bg color)
    behavior_paragraph_variant: layoutVariant,
    behavior_paragraph_alignment_layout: textAlign,
    // Glycerin Tracking
    behavior_paragraph_campaign_type: glycerinCampaignType,
    behavior_paragraph_campaignid: glycerinCampaginId,
    behavior_paragraph_category: glycerinCategory,
    behavior_paragraph_detail: glycerinDetail,
    behavior_paragraph_name: glycerinName,
  },
  link,
  linkTarget,
  linkRel,
  isLandscape,
}: LinkBoxItemContentComponentType) => (
  <div
    className={classes(
      'h-full px-0 py-1.5',
      isLandscape ? 'w-1/2' : 'w-full',
      layoutVariant === 'boxed' && 'px-1.5',
      textAlign === 'center' && 'content-center text-center',
      textAlign === 'right' && 'content-right text-right',
    )}
  >
    {subline && (
      <p>
        <SoftHyphenInjector text={subline} />
      </p>
    )}
    {headline && (
      <p className="text-size-headline-xl mb-1 font-semibold">
        <SoftHyphenInjector text={headline} />
      </p>
    )}
    {htmlContent && (
      <div className="mb-1">
        <CmsHtml
          data={{
            type: 'html',
            field_html_editor: htmlContent,
            field_text_align: textAlign === 'space-between' ? undefined : textAlign,
          }}
        />
      </div>
    )}
    {link !== '' && buttonText && buttonType && !['textlink', 'caption'].includes(buttonType) && (
      <LinkByButton
        data={{
          type: 'link_by_button',
          field_link: link,
          field_link_target: linkTarget,
          behavior_paragraph_link_rel: linkRel === '_none' ? undefined : linkRel,
          behavior_paragraph_alignment: textAlign === 'space-between' ? undefined : textAlign,
          field_text: buttonText,
          field_layout: mapButtonTypeToLayout(buttonType),
          behavior_paragraph_size: buttonSize,
          behavior_paragraph_campaign_type: glycerinCampaignType,
          behavior_paragraph_campaignid: glycerinCampaginId,
          behavior_paragraph_category: glycerinCategory,
          behavior_paragraph_detail: glycerinDetail,
          behavior_paragraph_name: glycerinName,
        }}
        icon={buttonIcon ? 'ArrowRight' : undefined}
      />
    )}
    {link !== '' && buttonText && buttonType === 'textlink' && (
      <LinkByText
        noUnderline
        data={{
          type: 'link_by_text',
          field_link: link,
          field_link_target: linkTarget,
          behavior_paragraph_link_rel: linkRel === '_none' ? undefined : linkRel,
          behavior_paragraph_alignment: textAlign === 'space-between' ? undefined : textAlign,
          field_text: buttonText,
          field_icon: buttonIcon ? 'ArrowRight' : undefined,
          behavior_paragraph_campaign_type: glycerinCampaignType,
          behavior_paragraph_campaignid: glycerinCampaginId,
          behavior_paragraph_category: glycerinCategory,
          behavior_paragraph_detail: glycerinDetail,
          behavior_paragraph_name: glycerinName,
        }}
      />
    )}
  </div>
);
